
/**
 * Utility functions for transportation events
 */

/**
 * Extract confirmation number from event description
 */
export const getConfirmationNumber = (description: string | null | undefined): string => {
  if (!description) return '';
  const match = description.match(/Confirmation:\s*([^\n]+)/);
  return match ? match[1].trim() : '';
};

/**
 * Get clean description (remove type and confirmation prefix)
 */
export const getCleanDescription = (description: string | null | undefined): string => {
  if (!description) return '';
  return description
    .replace(/Type:\s*[^\n]+\n?/, '')
    .replace(/Confirmation:\s*[^\n]+\n?/, '')
    .trim();
};

/**
 * Get user name from event
 */
export const getUserName = (event: any): string => {
  return event.user_name || 'Unknown';
};

